import { OrderCommonService } from 'modules/sales/common/services';
import { IOrder } from 'modules/sales/common/interfaces/IOrder';
import { format } from 'date-fns';
import { ApiClientService } from '@dfl/react-security';
import fileDownload from 'js-file-download';
import { ISubOrderDriver } from '../interfaces';
import { AssignDriver } from 'modules/inventory/provider/carriers/interfaces';

class SubOrderService extends OrderCommonService<IOrder> {
  exportToPDF = (filters: any) => {
    const time = format(new Date(), 'dd-MM-yyyy');
    const name = `suborders-${time}.pdf`;
    return ApiClientService.post(this.getPath('/pdfBulk?admin=true'), { filters }, { responseType: 'blob' }).then(
      ({ data }) => {
        fileDownload(data, name);
      },
    );
  };

  ticketDeliveryExport = (filters: any) => {
    const time = format(new Date(), 'dd-MM-yyyy');
    const name = `ticket-${time}.pdf`;
    return ApiClientService.post(
      this.getPath('/ticket-delivery/?admin=true'),
      { filters },
      { responseType: 'blob' },
    ).then(({ data }) => {
      fileDownload(data, name);
    });
  };

  updateDriver = (payload: ISubOrderDriver) => {
    const { _id, ...rest } = payload;
    if (_id) {
      return ApiClientService.post(this.getPath(`/${_id}/driver`), rest);
    }
    throw new Error('Suborder id is required');
  };

  complete = (id: string, params?: any, config?: any) => {
    return this.handleResponse(ApiClientService.post(this.getPath(`/${id}/complete`), params, config));
  };

  assignDriver = (params: AssignDriver) => {
    return this.handleResponse(ApiClientService.patch(this.getPath(`/${params?.order as string}/carrier`), params));
  };

  searchSubOrdersByDriver = (id: string, params?: any, config?: any) => {
    return this.handleResponse(ApiClientService.post(`/ms-sales/api/driver/${id}/suborders/search`, params, config));
  };

  searchSubOrdersByCarrier = (id: string, params?: any, config?: any) => {
    return this.handleResponse(ApiClientService.post(`/ms-sales/api/carrier/${id}/suborders/search`, params, config));
  };

  updateManyCarrier = (params: AssignDriver, orders: readonly string[]) => {
    return this.handleResponse(
      ApiClientService.patch(this.getPath('/bulk/carrier'), {
        ids: orders,
        ...params,
      }),
    );
  };

  updateOnDemandDate = (id: string, params: any) => {
    return this.handleResponse(ApiClientService.patch(this.getPath(`/${id}/shipping`), params));
  };
}

export default new SubOrderService('/ms-sales/api/suborder');
